"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancelCustomOrders = exports.cancelCustomOrder = void 0;
const rxjs_1 = require("rxjs");
const FutureAPI_1 = require("../../apis/FutureAPI");
__exportStar(require("./FutureTrade"), exports);
__exportStar(require("./SpotTrade"), exports);
const cancelCustomOrder = (params) => {
    return (0, FutureAPI_1.deleteCustomOrder)(params);
};
exports.cancelCustomOrder = cancelCustomOrder;
const cancelCustomOrders = (orders) => {
    return new rxjs_1.Observable((sub) => {
        const successOrders = [];
        const errorOrders = [];
        const checkResults = () => {
            const alreadyCount = successOrders.length + errorOrders.length;
            if (alreadyCount >= orders.length) {
                sub.next({ successOrders: successOrders, errorOrders: errorOrders });
                sub.complete();
            }
        };
        orders.forEach((e) => {
            (0, FutureAPI_1.deleteCustomOrder)({ order_id: e.order_id, symbol: e.symbol, accountType: e.accountType }).subscribe({
                next: () => {
                    successOrders.push(e);
                    checkResults();
                },
                error: () => {
                    errorOrders.push(e);
                    checkResults();
                },
            });
        });
    });
};
exports.cancelCustomOrders = cancelCustomOrders;
